/**
 *
 * @module entry
 * @desc {SDK.Internal.Telemetry} entry point.
 *
 */

import TelemetryManager from './telemetryManager';
import TelemetryEvent from './telemetryEvent';
import EventBuffer from './eventBuffer';
import StreamSampleTelemetryEvent from './streamSampleTelemetryEvent';

/**
 *
 * @typedef SDK.Internal.Telemetry
 * @type {Object}
 *
 * @property {TelemetryManager} TelemetryManager
 * @property {TelemetryEvent} TelemetryEvent
 * @property {EventBuffer} EventBuffer
 * @property {StreamSampleTelemetryEvent} StreamSampleTelemetryEvent
 *
 */

/**
 *
 * @type {SDK.Internal.Telemetry}
 *
 */
export default {

    TelemetryManager,
    TelemetryEvent,
    EventBuffer,
    StreamSampleTelemetryEvent

};



// WEBPACK FOOTER //
// ./src/internal/telemetry/entry.js